import lottoService from '@/service/lottoService'
import agentService from '@/service/agentService'

// ประเภทแทง 4 ตัว / 5 ตัว (huay-service docs/FOUR_FIVE_DIGIT_BETS.md)
// สวิตช์รายหวย + สิทธิ์ + คำถามเรื่องเลขเต็มอยู่ที่ huay-service · โหมดทั้งระบบอยู่ที่ agent-service
export default {
  // { [huayId]: [ประเภทที่ agent นี้ใช้ได้] } · master ได้ allowlist ทั้งหมด · agent ว่าง = ตัวเอง
  // inUse = ตัวกรองรายงาน: master ได้เฉพาะที่เปิดใช้จริงตอนนี้ — ปิดฟีเจอร์แล้วรายงานเหมือนเดิม
  // อ่านไม่สำเร็จ = ถือว่าไม่มีสิทธิ์ (ซ่อนประเภทใหม่ไว้ก่อน ปลอดภัยกว่า)
  // editable = ประเภทที่หน้าตั้งค่าแก้ได้: master ได้เฉพาะที่ติ๊กเปิดในหวยนั้น (agent อื่นเท่ากับที่เห็น)
  async access(agent, inUse = false, editable = false) {
    const params = [agent && `agent=${encodeURIComponent(agent)}`, inUse && 'inUse=true', editable && 'editable=true']
      .filter(Boolean)
    try {
      const res = await lottoService.getAuthen(`four-five-digit/access${params.length ? `?${params.join('&')}` : ''}`)
      return res && res.status === 200 && res.data ? res.data : {}
    } catch {
      return {}
    }
  },
  // หน้าตั้งค่า: { visible, editable } ต่อหวย · เห็นเมื่อเปิดโหมด แต่แก้ได้เฉพาะประเภทที่ติ๊กเปิดในหวยนั้น
  async settingAccess(agent) {
    const [visible, editable] = await Promise.all([this.access(agent), this.access(agent, false, true)])
    return { visible, editable }
  },
  huaySettings() {
    return lottoService.getAuthen('four-five-digit/huay')
  },
  saveHuaySetting(huayId, enabledTypes) {
    return lottoService.putAuthen(`four-five-digit/huay/${encodeURIComponent(huayId)}`, { enabledTypes })
  },
  // { required, length, usesTopThree } · round ว่าง = รอบปัจจุบัน
  async resultRequirement(huayId, roundId) {
    const query = roundId ? `?round=${encodeURIComponent(roundId)}` : ''
    try {
      const res = await lottoService.getAuthen(`four-five-digit/result-requirement/${encodeURIComponent(huayId)}${query}`)
      return res && res.status === 200 && res.data ? res.data : null
    } catch {
      return null
    }
  },
  mode() {
    return agentService.getAuthen('four-five-digit/mode')
  },
  saveMode(mode) {
    return agentService.putAuthen('four-five-digit/mode', { mode })
  },
}

// ค่าของโหมด — ตรงกับ enum FourFiveDigitMode ฝั่ง server
export const FOUR_FIVE_DIGIT_MODE = { OFF: 0, LINE: 1, ALL: 2 }

// ตั้งโหมดทั้งระบบและเปิดรายหวย: บัญชีหลังบ้านของ master ที่จัดการได้ทั้งหมด (เท่ากับ masterManageAllRoutes ของ router)
export const canManageFourFiveDigit = user => Boolean(user
  && ['admin', 'sub'].includes(user.role)
  && user.agent === 'master'
  && (user.ability || []).some(v => v.subject === 'all' && v.action === 'manage'))
